import { createSlice } from "@reduxjs/toolkit";

export const reviewSlice = createSlice({
  name: "review",
  initialState: {
    postLoading: false,
    postError: false,
    postStatusCode: 0,
    postMessage: "",
  },
  reducers: {
    onReviewPost: (state) => ({
      ...state,
      postLoading: true,
      postError: false,
      postStatusCode: 0,
      postMessage: "",
    }),
    onReviewPostSuccess: (state, { payload }) => {
      const { message = "", status_code = 200 } = payload ?? {};
      return {
        ...state,
        postLoading: false,
        postError: false,
        postStatusCode: status_code,
        postMessage: message,
      };
    },
    onReviewPostError: (state, { payload }) => {
      const { message = "", status_code = 400 } = payload ?? {};
      return {
        ...state,
        postLoading: false,
        postError: true,
        postStatusCode: status_code,
        postMessage: message,
      };
    },
    onReviewPostReset: (state) => ({
      ...state,
      postLoading: false,
      postError: false,
      postStatusCode: 0,
      postMessage: "",
    }),
    onGetReviews: (state) => ({
      ...state,
      getReviewsLoading: true,
      getReviewsError: false,
      getReviewsData: null,
      getReviewsMessage: "",
      getReviewsStatusCode: 0,
    }),
    onGetReviewsSuccess: (state, { payload }) => {
      const { data = null, message = "", status_code = 200 } = payload;
      return {
        ...state,
        getReviewsLoading: false,
        getReviewsError: false,
        getReviewsData: data,
        getReviewsMessage: message,
        getReviewsStatusCode: status_code,
      };
    },
    onGetReviewsError: (state, { payload }) => {
      const { data = null, message = "", status_code = 400 } = payload;
      return {
        ...state,
        getReviewsLoading: false,
        getReviewsError: true,
        getReviewsData: data,
        getReviewsMessage: message,
        getReviewsStatusCode: status_code,
      };
    },
    onGetReviewsReset: (state) => ({
      ...state,
      getReviewsLoading: false,
      getReviewsError: false,
      getReviewsData: null,
      getReviewsMessage: "",
      getReviewsStatusCode: 0,
    }), 
  },
});

export const {
  onReviewPost,
  onReviewPostSuccess,
  onReviewPostError,
  onReviewPostReset,
  onGetReviews,
  onGetReviewsSuccess,
  onGetReviewsError,
  onGetReviewsReset,
} = reviewSlice.actions;

export default reviewSlice.reducer;
